<div mat-dialog-title class="dialog-header aum-typo-headline-3">
    <div class="dialog-title">
        <span class="title-span"> {{ 'aumico_reports_accept_policy_dialog_title' | i18next }}</span>
    </div>
    <div class="seprator"></div>
    <div class="close-dialog">
        <mat-dialog-actions>
            <mat-icon (click)="closeDialog()" svgIcon="interface-delete 1"></mat-icon>
        </mat-dialog-actions>
    </div>
</div>
<div mat-dialog-content>
    <p>
        <span>
            {{ 'aumico_reports_accept_policy_dialog_first_paragraph' | i18next }}
        </span>
        <a class="aum-typo-paragraph privacy-policy" (click)="openTermsAndConditionsLink()">{{
            'aumico_reports_accept_policy_dialog_terms_and_conditions' | i18next
        }}</a>
        <span>
            {{ 'aumico_reports_accept_policy_dialog_first_paragraph_the' | i18next }}
        </span>
        <a class="aum-typo-paragraph privacy-policy" (click)="openPrivacyPolicyLink()">{{
            'aumico_reports_accept_policy_dialog_privacy_policy' | i18next
        }}</a>
        <span>
            {{ 'aumico_reports_accept_policy_dialog_first_paragraph_as_well_as_those' | i18next }}
        </span>
        <a class="aum-typo-paragraph privacy-policy" (click)="openAgreementOnOrderDataProcessingLink()">{{
            'aumico_reports_accept_policy_dialog_agreement_on_data_processing' | i18next
        }}</a>
        <span>
            {{ 'aumico_reports_accept_policy_dialog_first_paragraph_adjusted' | i18next }}
        </span>
    </p>

    <p>
        {{ 'aumico_reports_accept_policy_dialog_second_paragraph' | i18next }}
    </p>
    <p>
        {{ 'aumico_reports_accept_policy_dialog_third_paragraph' | i18next }}
    </p>
</div>
<div class="actions-footer">
    <mat-dialog-actions>
        <button aum-button color="blue" (click)="acceptPolicy()">
            {{ 'aumico_reports_accept_policy_to_continue_dialog_i_agree_button' | i18next }}
        </button>
    </mat-dialog-actions>
</div>
